
import { defineComponent } from 'vue'
import { Plan } from '../types/plan.types'
import { planService } from '../services/planService'
import PlanSettings from '../components/plan/PlanSettings.vue'

export default defineComponent({
    name: 'PlanEditWrapper',
    components: {
        PlanSettings,
    },
    props: {
        plan: {
            type: Object as () => Plan,
            required: true,
        },
        projectId: {
            type: String,
            required: true,
        },
        availableTasks: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            saving: false,
        }
    },
    methods: {
        async handleSave(formData: any) {
            this.$emit('save', formData)
        },

        async handlePublish(formData: any) {
            this.$emit('publish', formData)
        },

        handleCopy(plan: Plan) {
            // Эмитим событие для обработки копирования в родительском компоненте
            this.$emit('copy', plan)
        },

        async handleDelete(plan: Plan) {
            try {
                await planService.deletePlan(plan.id, this.projectId)

                // Эмитим событие для обновления данных в родительском компоненте
                this.$emit('delete', plan)

                // План успешно удален
            } catch (error) {
                // Ошибка удаления плана
            }
        },

        handleCancel() {
            this.$emit('close')
        },

        handleOpenPlanSettingsModal(plan: Plan) {
            this.$emit('open-plan-settings-modal', plan)
        },

        handleActivatePlan(plan: Plan) {
            this.$emit('activate-plan', plan)
        },

        // Метод для переинициализации данных в PlanSettings
        reinitializePlanData() {
            if (this.$refs.planSettings && (this.$refs.planSettings as any).loadTasks) {
                ;(this.$refs.planSettings as any).loadTasks()
            }
        },
    },
})
